jQuery(document).ready(function ($) {
    if ( $('.gtranslate_wrapper').length ) {
        // Apply changes to .gt_switcher-popup span:eq(0)
        $('.gt_switcher-popup span:eq(0)').each(function() {
            var $elem = $(this),
            $lang = $elem.text();
            const languages = {
                "English": "EN",
                "German": "DE"
            };
            $lang = $lang.replace(/English|German/g, match => languages[match]);
            $elem.text($lang);
        });
          
        // Apply changes to .gt_languages span
        $('.gt_languages span').each(function() {
            var $elem = $(this),
            $lang = $elem.text();
            const languages = {
                "English": "English - EN",
                "German": "German - DE"
            };
            $lang = $lang.replace(/English|German/g, match => languages[match]);
            $elem.text($lang);
        });
        
        jQuery('.glink[data-gt-lang]').click(function() {
            var lang = jQuery(this).data('gt-lang').toUpperCase();
            jQuery( ".gt_switcher-popup img + span").text( lang );
        });
        
        jQuery(window).on('scroll', function() {
            var scrollTop = jQuery(window).scrollTop(); // Get the scroll position
            var $targetSpans = jQuery('.gt_switcher_wrapper');
            
            // Check if the body has either 'single-blueprint' or 'single-event' class
            if (jQuery('body').find('.tps-nav-main-desktop').length != 1 ) {
                // If scroll position is >= 150px, hide the target element
                if (scrollTop >= 200) {
                    $targetSpans.fadeOut();
                } else {
                    $targetSpans.fadeIn();
                }
            }
        });
    }
});